<template>
  <div v-if="contractForms" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("ContractForms.name") }}</th>
            <th>{{ $t("ContractForms.description") }}</th>
            <th>{{ $t("notes") }}</th>
            <th>{{ $t("info") }}</th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              {{ $t("edit") }}
            </th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              {{ $t("delete") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ContractForm, index) in contractForms" :key="index">
            <td>{{ ++index + pagination.currentIndex }}</td>
            <td>
              {{ isDataExist(ContractForm.contractFormNameCurrent) }}
            </td>
            <td>
              <span class="cut-3line">
                {{ isDataExist(ContractForm.contractFormDescriptionCurrent) }}
              </span>
            </td>
            <td>
              {{ isDataExist(ContractForm.contractFormNotes) }}
            </td>
            <td>
              <button
                v-b-modal.ContractFormInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setContractForm(ContractForm)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              <router-link
                :to="{
                  name: 'ContractFormEdit',
                  params: {
                    contractFormToken: ContractForm.contractFormToken,
                  },
                }"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              <button
                v-b-modal.ContractFormDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setContractForm(ContractForm)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import privilegeMixin from "@/utils/privilege-mixin";
import { timeToLang, isDataExist } from "@/utils/functions";

export default {
  mixins: [privilegeMixin],
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
    };
  },
  props: ["contractForms", "pagination"],
  methods: {
    setContractForm(data) {
      this.$emit("setContractForm", data);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    isDataExist,
  },
  computed: {},
  async created() {},
};
</script>
